import {ITopBarRef, TopBar} from '../../../com/flyerPages/topBar/TopBar';
import {FlyerPages} from './flyerPages/FlyerPages';
import styles from './FlyerEditorContent.module.scss';

import './FlyerEditorContent.scss'
import {FlyerDto, PromoDto, PromoItemsDto, SelectPageForTabsDto} from '../../../../dtos'
import React, {useEffect, useRef, useState} from 'react'
import {useTypedSelector} from "../../../../hooks/useTypeSelector";
import {QualityCheck} from "../../../../com/qualityCheck/qualityCheck";
import {FlyerPromoItemsRightMenu} from "./unlinkMenuForPromosItemsScreen/rightMenu";
import {UnlinkHeader} from "./unlinkHeader/unlinkHeader";
import ZoomInOut from "../../spots/rightContent/flyerPages/controls/zoomInOut";
import {Box} from "@mui/material";

interface IFlyerEditorContent {
    data?: FlyerDto,
    onChangeSelectedPromos: (promo: PromoDto, event: React.MouseEvent<HTMLElement>, index: number) => void;
    onChangeSelectedItems: (item: PromoItemsDto, e: React.MouseEvent<HTMLElement>, isAllSelected?: boolean) => void;
    targetItems: PromoItemsDto[];
    isDragStart: boolean;
    setTargetItems: (items: PromoItemsDto[]) => void;
    targetUnlinkedPromos: PromoDto[];
    setTargetUnlinkedPromos: (promos: PromoDto[]) => void;
}

export const FlyerEditorContent: React.FC<IFlyerEditorContent> = (props) => {
    let selectedPageState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    const topBarReference = useRef<ITopBarRef>(null);

    const [pageIndex, setPageIndex] = useState(1);

    const onPageIndexChanges = (index: number) => {
        setPageIndex(index)
    }

    useEffect(() => {
        setPageIndex(selectedPageState.pageNo === 0 ? 0 : selectedPageState.pageNo - 1);
    }, [selectedPageState.pageNo])

    return (
        <div className="flyer_promos_editor_content">
            <TopBar
                screen={"promos"}
                ref={topBarReference}
                total={props.data?.flyerPages?.length!}
                onPageIndexChanges={onPageIndexChanges}
                pageIndex={pageIndex}
                isDragStart={props.isDragStart}
                leftChildren={(
                    <QualityCheck/>
                )}
                rightChildren={(
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: "center",
                            columnGap: "12px"
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: "center",
                            }}
                        >
                            <ZoomInOut/>
                        </Box>
                        <UnlinkHeader isOpen={promotionsItemsState.isOpenUnlinkMenu}/>
                    </Box>
                )}
            />
            <div className={styles.right_content_wrapper}>
                <FlyerPages
                    data={props.data}
                    isDragStart={props.isDragStart}
                    pageIndex={pageIndex}
                    onLeftArrowClick={() => topBarReference.current!.showBack()}
                    onNextArrowClick={() => topBarReference.current!.showNext()}
                    total={props.data?.flyerPages?.length!}
                />
                {promotionsItemsState.isOpenUnlinkMenu &&
                    <FlyerPromoItemsRightMenu
                        onChangeSelectedPromos={props.onChangeSelectedPromos}
                        onChangeSelectedItems={props.onChangeSelectedItems}
                        targetItems={props.targetItems}
                        setTargetItems={props.setTargetItems}
                        setTargetUnlinkedPromos={props.setTargetUnlinkedPromos}
                        targetUnlinkedPromos={props.targetUnlinkedPromos}
                    />
                }
            </div>

        </div>
    )
}